export enum PublicContactSource {
  Website = 0,
}

export interface PublicContactRequest {
  fullName: string;
  email?: string | null;
  phone?: string | null;
  subject?: string | null;
  message: string;
  source: PublicContactSource;
}

export interface PublicBookClient {
  fullName: string;
  phone: string;
  email?: string | null;
  age?: number | null;
  gender?: string | null;
  notes?: string | null;
}

export interface PublicBookServiceInput {
  serviceId: string;
  quantity: number;
}

export interface PublicBookRequest {
  branchId?: string | null;
  scheduledAt: string;
  notes?: string | null;
  client: PublicBookClient;
  services: PublicBookServiceInput[];
}

export interface PublicBookResponse {
  appointmentId: string;
  clientId: string;
  scheduledAt: string;
  organizationName: string;
  clientName: string;
  phone: string;
  isExistingClient: boolean;
}
